export * as tokens from "./tokens";
export * as contracts from "./contracts";
export * as tokenDefinitions from "./tokens/definitions";
export const name = "bitlayer-mainnet";
export const id = 200901;